import { Notification } from '../../../common/notification'
import { SelectCurrencyUnit } from '../../../common/selectCurrencyUnit'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { COMPANY_TYPES } from '../../../utils/common'
import { CompanyInfo } from '../../common/header/companyInfo'
import useCheckIsCompanyType from '../../common/header/companyInfo/useCheckIsCompanyType'
import { Filter } from '../../common/header/filterBar'
import { Layout } from '../../Layout'
import { Bottom } from './bottom'
import { LeftFilter } from './bottom/LeftFilter'
import './lang/i18n'

const IndustryAnalysis = () => {
  const isUnavailable = useCheckIsCompanyType([
    COMPANY_TYPES.FUNDS,
    COMPANY_TYPES.INSURANCE,
  ])

  return (
    <Layout
      renderTopComponent={() => <CompanyInfo />}
      renderStickyComponent={() => (
        <Filter
          renderLeft={() => <LeftFilter />}
          renderRight={() => (
            <SelectCurrencyUnit screen={SCREEN.INDUSTRY_ANALYSIS} />
          )}
        />
      )}
      renderBottomComponent={() =>
        isUnavailable ? (
          <Notification
            isI18n
            value="errorCommon.COMPANY_TYPE_ERROR"
            style={{ fontSize: 20 }}
          />
        ) : (
          <Bottom />
        )
      }
      isShowFooter={false}
    />
  )
}

export default IndustryAnalysis
